import instance from "http/Manager";
import { headers } from "http/Settings";


export const get_dictionaries = () => {
  return instance.get(`/v1/ws/dictionaries`, { headers });
}

export const get_home = () => {
  return instance.get(`/v1/ws/home`, { headers });
}

export const get_tamima = () => {
  return instance.get(`/v1/ws/tamima`, { headers });
}

export const get_whitepaper = () => {
  return instance.get(`/v1/ws/whitepaper`, { headers });
}

export const get_roadmap = () => {
  return instance.get(`/v1/ws/roadmap`, { headers });
}

export const get_social = () => {
  return instance.get(`/v1/ws/social`, { headers });
}

export const get_characters = (page = 1, price = null, date = null) => {
  return instance.get(`/v1/ws/characters`, { headers, params: { page, price, date } });
}

export const get_blogs = () => {
  return instance.get(`/v1/ws/blogs`, { headers });
}
